module.exports = __webpack_public_path__ + "img/58.92a473ec.jpg";